// Input text with Text area
const InputTextAreaField = ({
  name,
  placeholder,
  disabled,
  onBlur,
  value,
  error,
  pageInfo = {},
  onChange,
  customStyle,
  ref,
  autoFocus,
  maxLength = '2000',
  ...other
}) => {
  return (
    <>
      <>
        <textarea
          placeholder={placeholder}
          name={name}
          className="form-controlBox"
          disabled={disabled}
          onBlur={onBlur}
          defaultValue={value}
          onChange={onChange}
          style={customStyle}
          ref={ref}
          autoFocus={autoFocus}
          maxLength={maxLength}
          {...other}
        ></textarea>
      </>
      <span style={{ color: 'red' }}>{error && <label>{error}</label>}</span>
    </>
  );
};
export default InputTextAreaField;
